<template>
  <div class="home">
    <img alt="LNS logo" src="../assets/lns_sun.png">
    <p>
      Bienvenue sur la suite d'outils pour le jeu de rôle "Le Nouveau Soleil" à destination des joueurs et maîtres de jeu.
    </p>
    <p>
      <a href="https://www.nouveau-soleil.com/" target="_blank" rel="noopener">Site officiel</a>
    </p>
  </div>
</template>

<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>

<script lang="ts">

export default {}

</script>
